import {
  Divider,
  List,
  ListItem,
  ListItemText,
  Typography,
  TextField,
  InputLabel,
  Select,
  FormControl,
  FormHelperText,
  FormHelperTextProps,
} from '@material-ui/core';
import { isNull, startCase } from 'lodash';
import React, { Fragment, useEffect, useCallback, memo, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { amber, red, blue, teal } from '@material-ui/core/colors';
import { ContentMedia, MediaType, VideoSite, VideoType } from '@lib/content';
import { usePintMaster } from '@lib/common';
type EnumObject = { label: React.ReactNode; value: any };
type EnumMap = EnumObject[];
import { camelCase } from 'lodash';
import { Autocomplete } from '@material-ui/lab';
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';

export const createEnumMap = (enum_: Record<string, any>, retainSpecialChars = true): EnumMap =>
  Object.values(enum_).map(value => ({
    label: retainSpecialChars ? value : startCase(camelCase(value)),
    value,
  }));

const VideoSiteOptions = createEnumMap(VideoSite);
const VideoTypeOptions = createEnumMap(VideoType);

export const MediaDialogContent = memo<any>(
  ({ saveMedia, defaultValue, OkPressed, setOkPressed }) => {
    const [video_name, setVideoName] = useState(defaultValue ? defaultValue.video_name : null);
    const [video_site, setVideoSite] = useState(defaultValue ? defaultValue.video_site : null);
    const [path, setPath] = useState(defaultValue ? defaultValue.path : null);
    const [video_type, setVideoType] = useState(defaultValue ? defaultValue.video_type : null);
    const [language_id, setLanguageId] = useState(defaultValue ? defaultValue.language_id : null);
    const [vtrId, setVtrId] = useState(defaultValue ? defaultValue.vtr_id : null);
    const [touched, setTouched] = useState<Boolean>(false);
    useEffect(() => {
      if (OkPressed) {
        const saveMediaDetails = {
          video_name: video_name,
          video_site: video_site,
          path: path,
          video_type: video_type,
          language_id: language_id,
          ...(vtrId ? { vtr_id: vtrId } : null),
        };
      if (video_name && video_site && path && video_type && language_id &&
           (!path.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g))){
          
          saveMedia(saveMediaDetails);
        }
          
        setOkPressed(false);
      }
    }, [OkPressed]);
    // useEffect(
    //   () =>
    //     setPath(
    //       video_site
    //         ? video_site == VideoSite.YouTube
    //           ? 'https://youtu.be/' + (path || '').replace('https://youtu.be/', '')
    //           : 'https://vimeo.com/' + (path || '').replace('https://vimeo.com/', '')
    //         : path
    //     ),
    //   [video_site]
    // );

    return (
      <>
        {/* <Typography variant="subtitle1">Video Name</Typography> */}
        <br />
        <ControlledTextField
          fullWidth
          variant="outlined"
          value={video_name}
          setValue={setVideoName}
          setTouched={setTouched}
          touched={touched}
          label={'Video Name'}
        />
        {/* <Typography variant="subtitle1">Video Site</Typography> */}
        <br />
        <ControlledSelectField
          fullWidth
          variant="outlined"
          value={video_site}
          setValue={setVideoSite}
          setTouched={setTouched}
          touched={touched}
          label={'Video Site'}
          EnumOptions={VideoSiteOptions}
        />
        {/* <Typography variant="subtitle1">Video Path</Typography> */}
        <br />
        <ControlledTextField
          fullWidth
          variant="outlined"
          value={path}
          setValue={setPath}
          setTouched={setTouched}
          touched={touched}
          label={'Video Path'}
          video_site={video_site}
          path={path}
        />
        {/* <Typography variant="subtitle1">Video Type</Typography> */}
        <br />
        <ControlledSelectField
          fullWidth
          variant="outlined"
          value={video_type}
          setValue={setVideoType}
          touched={touched}
          setTouched={setTouched}
          label={'Video Type'}
          EnumOptions={VideoTypeOptions}
        />
        {/* <Typography variant="subtitle1">Video Language</Typography> */}
        <br />
        <ControlledAutoCompleteLanguageField
          fullWidth
          variant="outlined"
          value={language_id}
          setValue={setLanguageId}
          touched={touched}
          setTouched={setTouched}
          label={'Video Language'}
        />
      </>
    );
  }
);

const ControlledSelectField = ({
  value,
  setValue,
  label,
  touched,
  setTouched,
  EnumOptions,
  ...props
}) => {
  return (
    <>
      <FormControl variant="outlined" fullWidth size={'medium'}>
        <InputLabel id={`content-${label}`}>{label}</InputLabel>
        <Select
          labelId={`content-${label}`}
          id={`content-id-${label}`}
          native
          label={label}
          value={value}
          error={touched ? !value : false}
          onFocus={evt => setTouched(true)}
          onChange={evt => setValue(evt.target.value)}>
          <option value={''}></option>
          {EnumOptions.map((eachOption, indx) => (
            <option value={eachOption.value} key={indx}>
              {eachOption.label}
            </option>
          ))}
        </Select>
        <FormHelperText error={touched ? !value : false}>
          {touched ? (value ? null : `${label} is mandatory`) : null}
        </FormHelperText>
      </FormControl>
      {!(touched && !value) ? (
        <>
          <br />
        </>
      ) : (
        <>
          <br />
        </>
      )}
    </>
  );
};
const ControlledTextField = ({ value, setValue, label, touched, setTouched, path=null, ...props }) => {
  const callbackOnChange = useCallback(e => setValue(e.target.value), []);
  // console.log({"video_props":props});
  return (
    <>
      <TextField
        {...props}
        value={value}
        label={label}
        size={'medium'}
        onChange={callbackOnChange}
        error={touched ? (!value || path?.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)) : false}
        helperText={

          touched
            ? value
              ? path?.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g) 
              ? "Please enter only video ID"
              : props.video_site
                ? props.video_site == VideoSite.YouTube
                  ? 'Video Path : https://youtu.be/' +
                    (value || '').replace('https://youtu.be/', '')
                  : 'Video Path : https://vimeo.com/' +
                    (value || '').replace('https://vimeo.com/', '')
                : 'Please enter the Video Path and the Video Site'
              : `${label} is mandatory`
            : null
          // touched
          //   ? value
            
          //     ? props.video_site
          //     ? path.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g) 
          //     // ? props.video_site == VideoSite.YouTube
              
          //     //     ? 'Video Path : https://youtu.be/' +
          //     //       (value || '').replace('https://youtu.be/', '')
          //     //     : 'Video Path : https://vimeo.com/' +
          //     //       (value || '').replace('https://vimeo.com/', '')
                    
                   
          //       : 'Please enter the Video Path and the Video Site'
          //     : 'Please enter only Video ID of Video Path'
                
          //     : `${label} is mandatory`
          //   : null
        }
        onFocus={evt => setTouched(true)}
      />
      {!(touched && (!value && path?.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g))) ? (
        <>
          <br />
        </>
      ) : (
        <>
          <br />
        </>
      )}
    </>
  );
};

const CountryStyles = styled.div`
  .MuiChip-root {
    background: ${blue[600]};
    color: white;
  }
  .MuiChip-deleteIcon {
    color: white;
  }
`;

const ControlledAutoCompleteLanguageField = ({
  value,
  setValue,
  label,
  touched,
  setTouched,
  ...props
}) => {
  const { loading: loadingmasters, master } = usePintMaster('languages');
  return (
    <CountryStyles>
      <Autocomplete
        value={value}
        onChange={(evt, v) => setValue(v)}
        options={master || []}
        getOptionSelected={(option, value) => option.id === value.id}
        getOptionLabel={option => option.name}
        onFocus={evt => setTouched(true)}
        renderInput={props => (
          <TextField
            label={label}
            fullWidth
            variant="outlined"
            error={touched ? !value : false}
            helperText={touched ? (value ? null : `${label} is mandatory`) : null}
            {...props}
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingmasters ? (
                    <>
                      <CircularProgress color="inherit" size={20} />
                      {props.InputProps.endAdornment}
                    </>
                  ) : null}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </CountryStyles>
  );
};
